export const DISCLOSURE_LISTS_SPACER = 10;
export const LEFT_SECTION_FOCUSABLE_SELECTORS = `button, div.pnr-disclosure-list--footer`;